/**
 * the DOMContentLoaded handler runs when the document is loaded, so it can see all the elements, including <img> below.
 * But it doesn’t wait for the image to load. So alert shows zero sizes.
 */
function menu() {
	/**
	 * Hamburger menu toggle active class and toggle the aria-expanded attr
	 */

	var popupMenuModule = document.querySelector('.js-popup-menu');
	let bodyTag = document.querySelector('body');
	let hamburgerButton = document.querySelector('.hamburger-button');
	let siteHeader = document.querySelector('.voyager-header');
	let headerMenu = document.querySelector('.voyager-header__menu');
	let headerHeight = (typeof (siteHeader) != 'undefined' && siteHeader != null) ? siteHeader.offsetHeight : '';
	let fixedBookingWidget = document.querySelector('.voyager-booking--position-fixed');
	let cookiePreference = document.querySelector('.voyager-footer__menu .voyager-footer__menu-item a[href$="/acc-cookies-panel-trigger/"], a[href*="acc-cookies-panel-trigger"]');

	if (bodyTag.classList.contains('js-header-overlay')) {
		bodyTag.style.paddingTop = `${headerHeight}px`;
	}

	if (typeof (fixedBookingWidget) != 'undefined' && fixedBookingWidget != null) {
		fixedBookingWidget.style.marginTop = `${headerHeight}px`;
	}
	// Add class to header when document is scrolled past 100px

	window.addEventListener('scroll', function (e) {
		if (window.scrollY > headerHeight) {
			siteHeader.classList.add('voyager-header--small');
			bodyTag.classList.add('body--on-scroll');
		} else {
			siteHeader.classList.remove('voyager-header--small');
			bodyTag.classList.remove('body--on-scroll');
		}
	});

	if (popupMenuModule !== null) {
		var popupMenu = new Popup_Menu();
		popupMenu.init();
	}

	if (typeof (hamburgerButton) != 'undefined' && hamburgerButton != null) {
		hamburgerButton.addEventListener('click', toggleMenu);
		function toggleMenu(el) {
			if (typeof (headerMenu) != 'undefined' && headerMenu != null) {
				if (hamburgerButton.classList.contains('hamburger-button--is-active')) {
					document.querySelector('body').classList.remove('disable-scroll');
					hamburgerButton.classList.remove('hamburger-button--is-active');
					hamburgerButton.setAttribute('aria-expanded', 'false');

					siteHeader.classList.remove('voyager-header__menu--visible');
					setTimeout(function () {
						headerMenu.removeAttribute('style');
					}, 1000);
				}
				else {
					document.querySelector('body').classList.add('disable-scroll');
					hamburgerButton.classList.add('hamburger-button--is-active');
					hamburgerButton.setAttribute('aria-expanded', 'true');
					siteHeader.classList.add('voyager-header__menu--visible');
					if (popupMenuModule !== null) {
						popupMenu.showDefaultMenu();
					}
					// else {
					//     headerMenu.style.setProperty('height', `calc(100vh - ${headerHeight}px)`, 'important');                        
					// }
				}
			}
		}

		// Reset the menu stuff if the window is resizes and the menu is active
		window.addEventListener('resize', function () {
			setTimeout(function () {
				hamburgerButton.setAttribute('aria-expanded', 'false');
				hamburgerButton.classList.remove('hamburger-button--is-active');

				if (typeof (headerMenu) != 'undefined' && headerMenu != null) {
					headerMenu.classList.remove('voyager-header__menu--visible');
					headerMenu.removeAttribute('style');
				}

				let submenuElement = document.querySelectorAll('.voyager-header__menu-item-has-children');
				for (let menuItem = 0; menuItem < submenuElement.length; menuItem++) {
					// Grab the anchor tag within the sub-menu
					let targetAnchor = submenuElement[menuItem];

					targetAnchor.classList.remove('voyager-header__submenu--open');
					targetAnchor.classList.add('voyager-header__submenu--closed');

					let subMenu = targetAnchor.lastElementChild;
					subMenu.classList.remove('voyager-header__submenu--expanded');
					subMenu.removeAttribute('style');
				}

			}, 300);
		});

		document.addEventListener('click', function (event) {
			if (event.target.matches('.hamburger-button')) {
				let submenuElement = document.querySelectorAll('.voyager-header__menu-item-has-children');
				for (let menuItem = 0; menuItem < submenuElement.length; menuItem++) {
					// Grab the anchor tag within the sub-menu
					let targetAnchor = submenuElement[menuItem].firstElementChild;
					// TargetAnchor the click on the link
					// targetAnchor.addEventListener('click', submenu);
					// Click on the Chevron
					let targetChevron = targetAnchor.nextElementSibling;
					targetChevron.addEventListener('click', submenu);
				}
			}
		}, false);


		// Add class to header when docuemnt is scrolled past 100px
		window.addEventListener('scroll', function (e) {

			if (window.scrollY > 0) {
				// code here
			}
			else {
				// code here
			}

		});


		// Get the sub menus
		function submenu(el) {

			// some code to execute
		}
	}
	// Avvio cookie consent tool settings hook
	if (document.body.contains(cookiePreference)) {
		cookiePreference.addEventListener('click', function (e) {
			e.preventDefault();
			if (typeof AvvioCC !== 'undefined') AvvioCC.showMoreDetails();
		});
	}

};

class Popup_Menu {
	constructor() {
		this.mainModule = document.querySelector('.js-popup-menu');
		if (this.mainModule !== null) {
			this.menuItem = this.mainModule.querySelectorAll('.js-popup-menu-item') ?? false;
			this.menuName = this.mainModule.querySelector('.js-menu-name');
			this.menuImage = this.mainModule.querySelector('.js-menu-image');
			this.menuCloseBtn = this.mainModule.querySelector('.js-popup-menu-close');
			this.hamburgerButton = document.querySelector('.hamburger-button');
		}
	}

	showDefaultMenu() {
		var _self = this,
			hasCurrent = true;
		_self.menuItem.forEach(function (item) {
			if (item.classList.contains('current-voyager-header__menu-item') && hasCurrent) {
				var featureImage = item.dataset.featureImage,
					menuName = item.dataset.menuName;

				_self.changeImageName(featureImage, menuName)
				_self.setDefaultClass(item);
				hasCurrent = false;
			}
		});
	}

	changeImageName(url, name) {
		var _self = this;
		_self.menuImage.style.backgroundImage = 'url("' + url + '")';
		// _self.menuImage.alt = name;
		if (_self.menuName !== null) {
			_self.menuName.innerText = name;
		}
	}

	menuItemHover() {
		var _self = this;
		_self.menuItem.forEach(function (item) {
			item.addEventListener('mouseover', function (e) {
				e.stopPropagation();
				var featureImage = item.dataset.featureImage,
					menuName = item.dataset.menuName;

				if (featureImage !== undefined && menuName !== undefined) {
					_self.changeImageName(featureImage, menuName)
				}
			})
		});
	}

	setDefaultClass(item) {
		var _self = this;
		if (item.parentNode.classList.contains('voyager-header__submenu')) {
			item = item.parentNode;
			item.classList.add('active_submenu');
			_self.openDefaultMenu(item);
			_self.setDefaultClass(item.parentNode);
		}
	}

	openDefaultMenu(item) {
		item.classList.add('is-active', 'js-voyager-accordion__content-show');
		var newItem = item.parentNode
		newItem.classList.add('is-active');

		newItem.querySelector('.js-voyager-accordion__trigger').classList.add('is-active')
	}

	menuClose() {
		var _self = this;
		_self.menuCloseBtn.addEventListener('click', function () {
			_self.hamburgerButton.click();
		})
	}

	init() {
		if (typeof (this.mainModule) === 'undefined' || this.mainModule === null) {
			return false
		}
		this.menuItemHover();
		this.menuClose();
	}
}



/**
 * Run the menu script only on the front end
 */
//let menuFrontEnd = document.body.querySelector('.voyager');
let menuFrontEnd = document.querySelector('.voyager');
if (typeof (menuFrontEnd) != 'undefined' && menuFrontEnd != null) {
	document.addEventListener("DOMContentLoaded", menu());
}